<template>
  <div
    class="ep-banner-item-insurance"
    :data-destination-type="destinationType"
    :data-destination-url="destinationUrl"
    :data-gp-mapp-seq="gpMappSeq"
    :data-ads-dtl-seq="adsDtlSeq"
    :data-ads-seq="adsSeq"
    :data-pay-yn="payYn"
    :data-insu-seq="seq"
    :data-insu-nm="name"
    :data-it-seq="itSeq"
    :data-comp-nm="compNm"
  >
    <div class="ep-banner-item-insurance-media">
      <img :src="imgPath" :alt="`${bannerName} 배너 이미지`" role="button" />
    </div>
  </div>
</template>

<script>
import { DESTINATION_TYPE } from "@/const";

export default /*#__PURE__*/ {
  name: "EpBannerItemInsurance",
  props: {
    imgPath: {
      type: String,
      default: ""
    },
    destinationType: {
      type: String,
      default: DESTINATION_TYPE.OUT_LINK // C: 지정페이지, D: 상세페이지, P: 프로모션
    },
    destinationUrl: {
      type: String,
      default: ""
    },
    gpMappSeq: {
      type: Number,
      default: null
    },
    adsDtlSeq: {
      type: Number,
      default: null
    },
    adsSeq: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    seq: {
      type: String,
      default: ""
    },
    itSeq: {
      type: String,
      default: ""
    },
    compNm: {
      type: String,
      default: ""
    },
    payYn: {
      type: String,
      default: "N"
    }
  },

  computed: {
    bannerName() {
      if (this.name && this.name !== "") {
        return this.name;
      } else {
        return this.compNm;
      }
    }
  }
};
</script>

<style lang="scss">
.ep-banner-item-insurance {
  display: flex;
  flex-direction: column;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: cover;

  &:before {
    content: "";
    width: 1px;
    margin-left: -1px;
    float: left;
    height: 0;
    padding-top: 220px / 390px * 100%;
  }

  &-media {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
